import { memo, useMemo } from 'react';
import Animated from 'react-native-reanimated';
import { BoxVariantProps } from '../../Box.types';
import { View, ViewStyle } from 'react-native';
import useStyle from '../../../../hooks/useStyle';
import { applyGradientStyles } from './BoxGradient.utils';

function BoxGradient({
  id,
  children,
  gradient = 'accentBackground',
  animatedStyle,
  onLayout,
  ...rest
}: BoxVariantProps<'gradient'>) {
  const style = useStyle<ViewStyle>(rest);
  const Component = animatedStyle ? Animated.View : View;
  const gradientStyle = useMemo(
    () => applyGradientStyles(style, gradient),
    [style, gradient],
  );

  return (
    <Component
      id={id}
      style={animatedStyle ? [gradientStyle, animatedStyle] : gradientStyle}
      onLayout={onLayout}
      data-hoverable={true}
    >
      {children}
    </Component>
  );
}

export default memo(BoxGradient);
